import React, { useEffect, useState } from 'react'
import PageContainer from 'src/components/container/PageContainer'
import Appointments from './Appointments'
import { Box, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useMain } from '../hooks/useMain'
import ShowLoader from 'src/components/CustomComponents/ShowLoader'
import DashboardCard2 from 'src/components/shared/DashboardCard2'
import { Search } from '@mui/icons-material'

const data = [
    {
        clientName: 'John Doe',
        dateOfAppointment: '2023-06-10',
        dateOfBooking: '2023-06-08',
        number: '1234567890',
        amount: 100,
        paid: 'Paid',
        pending: "Pending",
        notes: 'Lorem ipsum dolor sit amet',
        paymentMode: 'Cash',
    },
    {
        clientName: 'Jane Smith',
        dateOfAppointment: '2023-06-12',
        dateOfBooking: '2023-06-10',
        number: '9876543210',
        amount: 150,
        paid: true,
        pending: false,
        notes: 'Consectetur adipiscing elit',
        paymentMode: 'Credit Card',
    },
    // Add more data objects here
];

const AllAppointments = () => {
    const [data, setData] = useState([]);
    const [showLoader, setShowLoader]=useState(false);

    const { fetchAllAppointments } = useMain();

    const getData=async()=>{
        setShowLoader(true);
        const res=await fetchAllAppointments();
       
        setData(res?.data);
        setShowLoader(false);
    }

    useEffect(()=>{
        getData();

        return ()=>{}
    },[]);

    return (
        <PageContainer title="Appointment History" description="this contains all products">
            <DashboardCard2 title="Appointment History">
                <Grid container spacing={2} sx={{ mt: 1, mb: 3 }} alignItems="center">
                    <Grid item xs={6}>
                        <FormControl variant="standard" style={{ minWidth: 120 }}>
                            <InputLabel>Show per page</InputLabel>
                            <Select value={10} onChange={() => { }}>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} container justifyContent="flex-end">
                        <TextField
                            label="Search"
                            variant="standard"
                            fullWidth
                            style={{
                                maxWidth:'300px'
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Search />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                <Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12}>
                            <Appointments data={data} />
                        </Grid>
                    </Grid>
                </Box>
                {showLoader && <ShowLoader value={showLoader} />}
            </DashboardCard2>
        </PageContainer>
    )
}

export default AllAppointments